import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, ME, LOGOUT_USER } from "store/auth/actionTypes";
import { me, loginSuccess, logoutSuccess, authRequestFailed } from "store/auth/actions";

import {
  postLogin,
  getMe,
  postLogout,
} from "connection/backend";

import axiosApi from "connection/api";

function* loginUserSaga({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, user);
    if (response.status === 200) {
      axiosApi.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.data.access}`;
      yield put(me(history));
    } else {
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {
    yield put(authRequestFailed(error.response.data));
  }
}

function* meSaga({ payload: { history } }) {
  try {
    const response = yield call(getMe);

    if (response.status === 200) {
      let user = {
        username: response.data.username,
        group: response.data.group,
      };
      localStorage.setItem("user", JSON.stringify(user));
      yield put(loginSuccess(response.data));
      if (history.location.pathname === "/login") {
        history.push("/");
      }
    } else {
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {
    yield put(authRequestFailed(error.data));
  }
}

function* logoutUserSaga({ payload: { history } }) {
  try {
    const response = yield call(postLogout);

    if (response.status === 205) {
      localStorage.removeItem("user");
      yield put(logoutSuccess());
      history.push("/login");
    } else {
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {
    yield put(authRequestFailed(error.data));
  }
}

export default function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUserSaga);
  yield takeEvery(ME, meSaga);
  yield takeEvery(LOGOUT_USER, logoutUserSaga);
}